/*********************************************************
 *                  School Service Ctrl
 ********************************************************/


"use strict";

angular.module("manager")
	.controller("SchoolServiceCtrl", [
		"$scope","Utils", "$uibModal", "LeafletService", "$sanitize",
		function ($scope,Utils, $uibModal, LeafletService, $sanitize) {

		var addModal;

		$scope.LeafletService = LeafletService;
		LeafletService.setCenter({
			lat:  48.0833,
			lng: -4.1833,
			zoom: 8,
		});
		$scope.data = {
			selectedSchoolService: {},
			networks: {}

		};

		/**
		 * Ouvrir la popup pour ajout d'un établissement.
		 */
		$scope.addSchoolService = function () {



			addModal = Utils.openModal($uibModal, "addModalTemplate.html", $scope);

			var name  = $scope.data.selectedSchoolService.name;
			// var HLPDurationTheorical  = $scope.data.selectedSchoolService.HLPDurationTheorical;
			// var HLPKmTheorical  = $scope.data.selectedSchoolService.HLPKmTheorical;
			// var HLPDurationCommercial  = $scope.data.selectedSchoolService.HLPDurationCommercial;
			// var HLPKmCommercial  = $scope.data.selectedSchoolService.HLPKmCommercial;
			// var network  = $scope.data.networks[0].name;
			// var line  = $scope.data.currentLine;
			// var route  = $scope.data.currentRoute;
			var course  = $scope.data.courses[0].public_name;

			$scope.recap = name + " : " + course;

		};

		$scope.validateSchoolService = function () {
			makeTabInfoSchoolService($scope.data.courses[0].public_name);
			$("#addSchoolServiceForm").attr("selected","-1");
			addModal.close();
		};

		function makeTabInfoSchoolService (course) {
			$("#tableSchoolService").show();

			var html = "";
			html += "<tr style='height: 45px; border-bottom: 1px grey solid;'>";
			html += "<td class='col-md-2' style='text-align: center;'></td>";
			html += "<td class='col-md-2' style='text-align: center;'><select class='form-control'><option>-- Zone de départ --</option><option>Dépôt 1</option><<option>Dépôt 2</option>/select></td>";
			html += "<td class='col-md-2' style='text-align: center;'>"+ $sanitize(course) +"</td>";
			html += "<td class='col-md-2' style='text-align: center;'><select class='form-control'><option>-- Zone d'arrivée --</option><option>Dépôt 2</option><option>Dépôt 3</option></select></td>";
			html += "<td class='col-md-2' style='text-align: center;'><a title='Editer les informations du circuit scolaire' class='btn btn-primary' style='margin-right: 5px;'><span class='fa fa-pencil-alt'></span></a>";
			html += "<button title='Supprimer le circuit scolaire' ng-click='' class='btn btn-danger' style='margin-left: 5px;'><span class='fa fa-trash'></span></button></td>";
			html += "</tr>";

			$("#tableSchoolServiceRoute").append(html);

		}


	}]);